const FFP = {
  AEROFLOT: 'SU',
  AEROLINEAS: 'AR',
  AEROMAR: 'VW',
  AEROMEXICO: 'AM',
  ALASKA: 'AS',
  ALITALIA: 'AZ',
  AVIANCA: 'AV',
  AVIANCA_BRASIL: 'O6',
  CHINA_EASTERN: 'MU',
  CHINA_SOUTHERN: 'CZ',
  CHINA: 'CI',
  CLUB_PREMIER_CORPORATE: 'CORP',
  // COPA: 'CM',
  // CZECH: 'OK',
  DELTA: 'DL',
  EUROPA: 'UX',
  ELAL: 'LY',
  FRANCE: 'AF',
  GARUDA: 'GA',
  GOL: 'G3',
  KENYA: 'KQ',
  KLM: 'KL',
  KOREAN: 'KE',
  LATAM: 'LA',
  MIDDLE_EAST: 'ME',
  SAS: 'SK',
  SAUDIA: 'SV',
  TAROM: 'RO',
  VIETNAM: 'VN',
  VIRGIN_ATLANTIC: 'VS',
  WESTJET: 'WS',
  XIAMEN: 'MF',
  JET_AIRWAYS: '9W',
};

export default FFP;
